import { MessageContent } from "duck/ui/chat/serverSentEvents";
import { subthreadManager } from "duck/ui/chat/subthreadManager";
import { ChatMessage, ChatMessageRole } from "duck/ui/chat/types";

import { SubthreadStatus } from "./SubthreadStatusIndicator";
import { SubthreadContent } from "./types";

export const hasAiMessagesWithContent = (messages: ChatMessage[]): boolean =>
  messages.some(
    (m) =>
      m.role === ChatMessageRole.AI &&
      m.state?.messages &&
      m.state.messages.length > 0
  );

export const parseSubthreadContent = (
  content: MessageContent
): SubthreadContent | null => {
  if (typeof content !== "object") {
    return null;
  }

  return content as SubthreadContent;
};

export const getInitialStatus = (
  threadId: string | undefined
): SubthreadStatus => {
  if (!threadId) {
    return SubthreadStatus.STREAMING;
  }

  const state = subthreadManager.getState(threadId);

  if (state.isStreaming) {
    return SubthreadStatus.STREAMING;
  }

  return state.messages.length > 0
    ? SubthreadStatus.COMPLETED
    : SubthreadStatus.STREAMING;
};
